//I18n
import Translate from '../../i18n/Translate'

//Intersection
import { useInView } from 'react-intersection-observer'

//Images
import sustainabilityMb from '../../assets/images/about/sustainability-img-mb@2x.jpg'
import sustainabilityDt from '../../assets/images/about/sustainability-img-dt@2x.jpg'

const Sustainability = () => {
    const [title, inView] = useInView({
        triggerOnce: true,
        threshold: 0.5,
    })

    return (
        <section className="incoming-about__sustainability">
            <div className="text-container">
                <h2 className={`title animate slide-right ${inView ? 'in-view' : ''}`} ref={title}>
                    <Translate langkey="about.sustainability.title" />
                </h2>

                <div className="copy">
                    <p>
                        <Translate langkey="about.sustainability.copy1" />
                    </p>
                    <p>
                        <Translate langkey="about.sustainability.copy2" />
                    </p>
                    <p>
                        <Translate langkey="about.sustainability.copy3" />
                    </p>
                    <p>
                        <strong>
                            <Translate langkey="about.sustainability.copy4" />
                        </strong>
                    </p>
                    {/* 
                    <p>
                        <Translate langkey="about.sustainability.copy5" />
                    </p>
                    */}
                </div>
            </div>

            <div className="sustainability-img">
                <picture>
                    <source media="(min-width: 600px )" srcSet={`${sustainabilityDt}`} />
                    <img src={sustainabilityMb} alt="Sustainability" />
                </picture>
            </div>
        </section>
    )
}

export default Sustainability
